import * as React from "react";
import * as SwitchPrimitive from "@radix-ui/react-switch";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const switchVariants = cva(
  "group peer inline-flex shrink-0 cursor-pointer items-center rounded-pill border-2 border-transparent transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=unchecked]:bg-muted-foreground/20",
  {
    variants: {
      size: {
        default: "h-5 w-12",
        sm: "h-4.5 w-9",
        xs: "h-4 w-7",
      },
    },
    defaultVariants: {
      size: "default",
    },
  }
);

const thumbVariants = cva(
  "pointer-events-none block rounded-pill bg-background ring-0 transition-all duration-200 data-[state=checked]:bg-white",
  {
    variants: {
      size: {
        default: "h-4 w-[26px] data-[state=checked]:translate-x-[18px] data-[state=unchecked]:translate-x-0 group-active:h-3.5 group-active:w-[24px] data-[state=unchecked]:group-active:translate-x-[2px]",
        sm: "h-3.5 w-[20px] data-[state=checked]:translate-x-[12px] data-[state=unchecked]:translate-x-0 group-active:h-3 group-active:w-[18px] data-[state=unchecked]:group-active:translate-x-[2px]",
        xs: "h-3 w-[16px] data-[state=checked]:translate-x-[8px] data-[state=unchecked]:translate-x-0 group-active:h-2.5 group-active:w-[14px] data-[state=unchecked]:group-active:translate-x-[2px]",
      },
    },
    defaultVariants: {
      size: "default",
    },
  }
);

function Switch({
  className,
  size,
  ...props
}: React.ComponentProps<typeof SwitchPrimitive.Root> &
  VariantProps<typeof switchVariants>) {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      className={cn(switchVariants({ size, className }))}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className={cn(thumbVariants({ size }))}
      />
    </SwitchPrimitive.Root>
  );
}

export { Switch };